import { svg } from "lit";

export function closeIcon() {
  return svg`
<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.66504 0.665039L0.665039 8.66504M0.665039 0.665039L8.66504 8.66504" stroke="currentColor" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`;
}
